module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16i6QdB/images/cover.jpg?1685327426085",
      "alt": "This image is the cover for the book A Solstice Journey"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Solstice Journey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Upon leaving his company's Christmas party, Gunnar Dagviðurson decides to walk to the train and enjoy the snowfall, only to get caught in a winter storm that magically transports him to a mysterious foreign realm. That’s how Celyn finds him, stumbling blindly through the snow, and Celyn takes Gunnar home to a castle of faery. Gunnar wants to find his way home for Christmas, but suddenly he’s faced with a choice: does he go back to his adopted family in the human world or stay with the magical family he’s found?")]), _c('p', [_c('i', [_vm._v("A story from the Dreamspinner Press 2013 Advent Calendar package \"Heartwarming\".")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Felicitas Ivey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0